module.exports = __webpack_public_path__ + "assets/img/login_banner_cn.e450d212.jpg";